module.exports = __webpack_public_path__ + "static/media/square-leaf-img.e4cd862e.svg";